<template>
  <div class="flex w-full">
    <multiselect
      v-model="encuesta"
      :options="options"
      :placeholder="$t('forms.encuesta.multiselect')"
      label="descripcion"
      track-by="id"
      :disabled="isOnlyView"
      :internal-search="false"
      :clear-on-select="false"
      :allow-empty="false"
      :options-limit="300"
      @close="onTouch"
      @search-change="find"
      @select="handleSelected"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { baseMixin } from "@/mixins/base";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Multiselect,
  },
  mixins: [baseMixin],
  data() {
    return {
      encuesta: null,
      isTouched: false,
    };
  },
  props: {
    modelValue: {
      type: [String, Number, Object],
      required: true,
      default: null,
    },
    isOnlyView: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    await this.loadEncuestas();
  },
  computed: {
    ...mapGetters(["getEncuestaListState"]),
    options() { return this.getEncuestaListState || []; } 
  },
  methods: {
    ...mapActions([
      "getEncuestaList",
      "setEncuestaList",
      "getEncuestaById",
      "setEncuesta",
    ]),
    async loadEncuestas() {
      await this.find(null);
      this.setEncuesta(this.modelValue);
    },
    async find(query) {
      try {
        const res = await this.getEncuestaList({ search: query, page: 1 });
        const { results } = await res.json();
        this.setEncuestaList(results);
      } catch (err) {
        console.error(err);
      }
    },
    onTouch() {
      this.isTouched = true;
    },
    handleSelected(value) {
      this.$emit("update:modelValue", value);
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue) {
        this.encuesta = newValue;
      },
    },
  }
};
</script>

<style scoped>
/* Agrega estilos personalizados si es necesario */
</style>
